export enum RouteKeys {
  List = '/user',
  Details = '/user/:id',
}
